// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_NDM","cls2":"LoswpPackPitch-cls2_CwB LoswpPackPitch-cls1_NDM"};